import { Level } from '@paragon/contract-library';

import { RootState } from '../../../../store';
import {
  getAllBearingEnvelopes,
  getAllFeaturePatternContainers,
  getAllRoofContainers,
  getAllRoofPlanes,
  getAllTrussEnvelopes,
} from '../../../../store/selectors/layoutDataSelectors';
import { useAppSelector } from '../../../hooks';

export function LevelSecondaryText({ level }: { level: Level }) {
  function useFilteredSelector<T extends { levelGuid: string | null }>(selector: (state: RootState) => T[]) {
    return useAppSelector(selector).filter((item) => item.levelGuid === level.guid);
  }

  const bearingEnvelopes = useFilteredSelector(getAllBearingEnvelopes);
  const featurePatternContainers = useFilteredSelector(getAllFeaturePatternContainers);
  const roofContainers = useFilteredSelector(getAllRoofContainers);
  const roofPlanes = useFilteredSelector(getAllRoofPlanes);
  const trussEnvelopes = useFilteredSelector(getAllTrussEnvelopes);

  if (trussEnvelopes.length > 0) {
    const designedCount = trussEnvelopes.filter((envelope) => envelope.componentDesignGuid != null).length;
    let trussesDesc = `${trussEnvelopes.length} trusses`;
    if (designedCount > 0) {
      trussesDesc += ` (${designedCount === trussEnvelopes.length ? 'all' : designedCount} designed)`;
    }
    return trussesDesc;
  }

  const typesOfImportantObjects = [
    roofContainers.length > 0,
    roofPlanes.length > 0,
    featurePatternContainers.length > 0,
  ].filter(Boolean).length;

  if (typesOfImportantObjects >= 2) return 'Mixed';
  if (roofContainers.length > 0) return `Roof Container${roofContainers.length > 1 ? 's' : ''}`;
  if (roofPlanes.length > 0) return `Roof Plane${roofPlanes.length > 1 ? 's' : ''}`;
  if (featurePatternContainers.length > 0) return 'Feature Pattern';

  const hasWalls = bearingEnvelopes.some((e) => e.bearingType === 'Wall');
  const hasBeams = bearingEnvelopes.some((e) => e.bearingType === 'Beam');

  if (hasWalls && hasBeams) return 'Only Walls and Beams';
  if (hasWalls) return 'Only Walls';
  if (hasBeams) return 'Only Beams';

  return 'Empty';
}
